import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const UpgradeRedirect = ({ user, team, history, isLoggedOut }) => {
  useEffect(() => {
    if (user) {
      const userTeamId = user.teams[0] && user.teams[0].team;

      history.replace(`/dash/team/${userTeamId}/billing`, {
        showPurchaseModal: true
      });
    }
  }, [history, user, team, isLoggedOut]);

  return <span />;
};

UpgradeRedirect.propTypes = {
  user: PropTypes.object,
  team: PropTypes.object,
  history: PropTypes.object,
  isLoggedOut: PropTypes.bool
};

export default withRouter(
  connect(state => {
    const { user, team, isLoggedOut } = state;

    return { user, team, isLoggedOut };
  }, {})(UpgradeRedirect)
);
